import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectWrapperPlatform } from '@/store/selectors/commonSelectors';
import { syncAndroidWrapperClass } from '@/utils/platform-class';

const useWrapperPlatformClass = (): void => {
  const platform = useSelector(selectWrapperPlatform);

  useEffect(() => {
    syncAndroidWrapperClass(document.documentElement, platform);
  }, [platform]);
};

export default useWrapperPlatformClass;
